import React from 'react';
import './MidGridContent.css';

const MidGridContent = () => {
    return (
        <div className="mid__grid__content">
            <div className="mid__grid__login__p">
                <span>
                    Please enter your email and password to login
                </span>
            </div>
        </div>
    );
};

export default MidGridContent;